<template>
    <checkout-layout id="checkout-page" class="h-100">
        <div class="row">
            <div class="col-12">
                <h6 v-if="isFleetmanager && companyName" class="truncate" :title="companyName">Sie buchen im Auftrag der Firma {{ companyName }}</h6>
                <h1>{{$t('co.main.title')}}</h1>
                <p class="subtitle">{{$t('co.main.title.text')}}</p>
            </div>
            <div class="col-12 col-lg-8">
                <ad name="ad_above_checkout" class="mb-3"></ad>

                <ul class="list-group" v-if="!isBroken && !isLoading && subscriptionIsInCheckout">
                    <checkout-personal-data
                        :is-loading="isLoading"
                        :user="user"
                        :number-of-steps="numberOfSteps"
                    ></checkout-personal-data>

                    <checkout-address-data
                        v-if="user"
                        :entry="subscription"
                        :user="user"
                        :number-of-steps="numberOfSteps"
                    ></checkout-address-data>

                    <checkout-payment-data
                        v-if="user && paymentHandling"
                        :entry="subscription"
                        :customer="user"
                        :product="product"
                        :number-of-steps="numberOfSteps"
                    ></checkout-payment-data >

                    <checkout-handover-data
                        :entry="subscription"
                        :product="product"
                        :current-step="paymentHandling ? 4 : 3"
                        :number-of-steps="numberOfSteps"
                    ></checkout-handover-data>

                    <checkout-additional-services
                        v-if="isStarcar"
                        :current-step="paymentHandling ? 5 : 4"
                        :entry="subscription"
                        :numberOfSteps="numberOfSteps"
                    ></checkout-additional-services>

                    <checkout-legal-data
                        :entry="subscription"
                        :user="user"
                        :current-step="isStarcar && paymentHandling ? 6 : (paymentHandling ? 5 : 4)"
                        :product="product"
                        :number-of-steps="numberOfSteps"
                    ></checkout-legal-data>
                </ul>

                <ad name="ad_below_checkout" class="mt-3"></ad>

                <div class="alert alert-info" v-if="!isLoading && !subscriptionIsInCheckout">
                    <p>{{$t('co.main.error.notInCheckout')}}</p> <br>
                    <b-link :to="$getUrl('catalog')">{{$t('co.main.redirect')}}.</b-link>
                </div>
                <div class="alert alert-info" v-if="isBroken">
                    {{$t('co.main.error')}}
                    <b-link :to="$getUrl('catalog')">{{$t('co.main.redirect')}}.</b-link>
                </div>
            </div>
            <div class="col-12 col-lg-4 mt-3 mt-md-0" v-if="!isBroken">
                <div class="h-100">
                    <div :class="{ 'fixed': isFixed }">
                        <checkout-subscription-overview
                            :is-loading="isLoading"
                            :entry="product"
                            :subscription="subscription"
                        ></checkout-subscription-overview>

                        <partner-contact-box
                            class="mt-4"
                            :entry="product"
                            :is-loading="isLoading"
                        ></partner-contact-box>

                        <ad name="ad_below_contact" class="mt-3"></ad>
                    </div>
                </div>
            </div>
        </div>
    </checkout-layout>
</template>

<script>
import CheckoutLayout from '../../layouts/CheckoutLayout.vue'
import { BLink } from "bootstrap-vue";
import Ad from "../../components/atoms/Ad.vue";
import CheckoutSubscriptionOverview from "../../components/molecules/CheckoutSubscriptionOverview.vue";
import CheckoutPersonalData from "../../components/molecules/CheckoutPersonalData.vue";
import CheckoutAddressData from "../../components/molecules/CheckoutAddressData.vue";
import CheckoutPaymentData from "../../components/molecules/CheckoutPaymentData.vue";
import UpdatePaymentMethod from "../../components/molecules/UpdatePaymentMethod";
import CheckoutHandoverData from "../../components/molecules/CheckoutHandoverData.vue";
import CheckoutLegalData from "../../components/molecules/CheckoutLegalData.vue";
import CheckoutAdditionalServices from "../../components/molecules/CheckoutAdditionalServices.vue";
import { EventBus } from "../../event-bus";
import PartnerContactBox from "../../components/molecules/PartnerContactBox.vue";

export default {
    components: {
        Ad,
        CheckoutLegalData,
        CheckoutHandoverData,
        CheckoutPaymentData,
        UpdatePaymentMethod,
        CheckoutAddressData,
        CheckoutPersonalData,
        CheckoutSubscriptionOverview,
        CheckoutAdditionalServices,
        CheckoutLayout,
        PartnerContactBox,
        BLink
    },
    data() {
        return {
            identifier: this.getIdentifier(),
            isBroken: false,
            isLoading: true,
            subscription: null,
            product: null,
            user: null,
            scrollPosition: null,
            selectedCompany: JSON.parse(localStorage.getItem('selectedCompany')),
        }
    },
    methods: {
        initStripe: function () {
            this.$stripe.loadStripe(this.$root.whitelabel)
        },
        getIdentifier() {
            return this.$route.params.identifier ? this.$route.params.identifier : null
        },
        getCheckout() {
            if (this.identifier === null || this.identifier === undefined) {
                this.isLoading = false
                this.isBroken = true
            } else {
                this.$axios.post('api/v1/dashboard/show_subscriptions_identifier', {
                        identifier : this.identifier
                    }).then(response => {
                        this.subscription = response.data
                        if (this.subscription.stripe_key) {
                            this.$root.stripe.overwriteStripeSettings(this.subscription.stripe_key, this.subscription.payment_flow_type)
                        }

                        this.getProduct()
                        this.getUser()
                        this.isLoading = false
                }).catch(error => {
                    this.error = error.response.data.message
                });
            }
        },
        getProduct() {
            this.$axios.get(`/api/v1/catalog/vehicle/${this.subscription.vehicle.uuid}`, {})
                .then(response => {
                    this.product = response.data.data
                    this.googleAnalyticsInitEvent()
                })
                .catch(error => {
                    console.log(error)
                    this.error = error.response.data.message
                })
        },
        getUser() {
            this.$axios.get('/api/v1/profile/get_profile_data', {})
                .then(response => {
                    this.user = response.data
                }).catch(error => {
                    console.log(error)
                    this.error = error.response.data.message
                });
        },
        updateSubscription(data) {
            this.subscription = data
            this.$forceUpdate()
        },
        updateScroll() {
            this.scrollPosition = window.scrollY
        },
        googleAnalyticsInitEvent() {
            if (process.env.MIX_VUE_APP_ACTIVATE_GOOGLE_ANALYTICS && this.$gtag !== undefined && this.product) {
                this.$gtag.event('begin_checkout', {
                    currency: this.subscription.price_plan.currency.toUpperCase(),
                    items: [
                        {
                            item_id: this.product.id,
                            item_name: this.product.model.title,
                            item_brand: this.product.brand.title,
                            item_category: this.product.category.title,
                            subsidiary_id: this.$root.whitelabel.sub_id(),
                            price: this.subscription.price_plan.price,
                            mileage: localStorage.selectedMileage,
                            duration: localStorage.selectedDuration
                        }
                    ]
                })
            }
        }
    },
    mounted() {
        this.initStripe()
        EventBus.$on('update-subscription-payload', this.updateSubscription);
        EventBus.$on('update-subscription', this.getCheckout);
        window.addEventListener('scroll', this.updateScroll)
        this.getCheckout()
    },
    computed: {
        numberOfSteps() {
            let steps = 5
            if (this.subscription.subsidiary_has_own_payment_handling) {
                steps = 4
            }
            if (this.isStarcar) {
                steps += 1
            }

            return steps
        },
        paymentHandling() {
            if (this.subscription.subsidiary_has_own_payment_handling) {
                return false
            }
            return true
        },
        isFixed() {
            return this.scrollPosition > 81
        },
        subscriptionIsInCheckout() {
            return this.subscription.status === 'SUBSCRIPTION_IN_CHECKOUT'
        },
        companyName() {
            return this.selectedCompany.name ?? ''
        },
        isFleetmanager() {
            if(this.$root.user?.state?.data?.core_user?.fleetmanager?.status === 'inactive') {
                return false
            }
            return !!this.$root.user?.state?.data?.core_user?.is_fleetmanager
        },
        isStarcar() {
            return this.$root.whitelabel.state.starcar
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.updateScroll)
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.checkout.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.checkout.description') }
            ]
        }
    }
}
</script>
<style>
.truncate {
  display: inline-block;
  max-width: 70ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>